<template lang="">
  <section
    :class="{
      'mt-0': showInProductDetail,
      'mt-4 mt-lg-5 px-1 px-lg-0': !showInProductDetail,
    }"
  >
    <h2
      v-if="!showInProductDetail"
      class="title-payment-secure text-secondary px-3 px-lg-0"
      :class="{ 'text-dark': showInProductDetail }"
    >
      Pago seguro
    </h2>
    <div :class="{ 'row mt-3 mx-0 px-2 px-lg-0': !showInProductDetail }">
      <div
        v-if="!showInProductDetail"
        class="col-4 col-xl-6 row mx-0 px-0 row-gap-2 gx-2 gx-xl-3"
      >
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <span class="text-primary"> 100% Productos nuevos </span>
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <span class="text-primary"> Envío asegurado </span>
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <span class="text-primary"> Envío personalizado </span>
            <!-- Servicio personalizado -->
          </div>
        </div>
      </div>
      <div
        v-if="!showInProductDetail"
        class="col-4 col-xl-6 row mx-0 px-0 row-gap-2 gx-2 gx-xl-3"
      >
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            Precios bajos
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <span class="text-primary"> Pago seguro con tarjetas </span>
          </div>
        </div>
        <div class="col-12 col-xl-4">
          <div
            class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col subtitle-secure-payment"
          >
            <i class="bi bi-check2 text-success mx-lg-2" />
            <span class="text-primary"> Garantía directa </span>
          </div>
        </div>
      </div>
      <div
        class="col-xl-12 row mx-0 px-0 row-gap-2 gx-2 gx-xl-3 mt-0 gx-2 gx-xl-3"
        :class="{
          'mt-xl-0': showInProductDetail,
          'col-4 mt-xl-3': !showInProductDetail,
        }"
      >
        <div
          v-for="item in paymentMethods"
          v-show="item.show"
          :key="item.id"
          :class="{
            'col-2 col-lg-3': showInProductDetail,
            'col-6 col-xl-1': !showInProductDetail,
          }"
        >
          <div
            :class="{
              'payment-option-products': showInProductDetail,
              'h-100': !showInProductDetail,
            }"
          >
            <base-link
              :to="'/formas-de-pago'"
              :external="true"
              class="d-flex justify-content-start align-items-center p-1 p-lg-2 height-col"
              :class="{
                'mt-2 border border-light': showInProductDetail,
                'shadow-payment-img': !showInProductDetail,
              }"
            >
              <img
                v-lazy="item.image"
                :alt="item.name"
                class="image-payment mx-auto"
              />
            </base-link>
          </div>
        </div>
        <div v-if="!showInProductDetail" class="col-1 d-none d-xl-block">
          <base-link
            class="d-flex justify-content-center align-items-center p-1 p-lg-2 h-100 link-underline link-underline-opacity-0"
            :class="{ 'shadow-payment-img': !showInProductDetail }"
            :to="'/formas-de-pago'"
          >
            <span class="fs-7 text-primary text-nowrap"> Más info </span>
            <i class="bi bi-plus-circle-fill text-body-tertiary fs-6 mx-2" />
          </base-link>
        </div>
        <div
          class="d-flex"
          :class="{
            'd-none d-xl-block justify-content-end mt-0 col-3 col-xl-10 ms-5':
              showInProductDetail,
            'col-12 d-xl-none justify-content-center align-items-center height-col':
              !showInProductDetail,
          }"
        >
          <base-link
            :to="'/formas-de-pago'"
            class="link-underline link-underline-opacity-0 fs-10 h-100 m-0 d-flex justify-content-center align-items-center"
          >
            <span class="text-nowrap ps-3 ps-lg-0"> Ver todas las </span>
            <span class="text-info mx-1"> formas </span>
            <span class="text-nowrap">de pago</span>
            <i class="bi bi-plus-circle-fill text-info ms-1 fs-6" />
          </base-link>
        </div>
        <div
          v-if="showInProductDetail"
          class="col-4 col-lg-12 d-flex d-xl-none"
        >
          <base-link
            to="/"
            class="text-blue see-way-to-pay d-flex flex-column justify-content-center mt-3 mt-xxl-2 ms-1 mb-md-3 mb-xl-0"
          >
            <span> Ver todas las </span>
            <span> formas de pago </span>
          </base-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import BaseLink from "@/components/buttons/BaseLink.vue";
import type { PaypmentMethodHome } from "@/interfaces/PaypmentMethodMeta";
export default {
  components: {
    BaseLink,
  },
  props: {
    showInProductDetail: {
      type: Boolean,
      default: false,
    },
    showMaster: {
      type: Boolean,
      default: true,
    },
    showMaster2: {
      type: Boolean,
      default: true,
    },
    showVisa: {
      type: Boolean,
      default: true,
    },
    showVisa2: {
      type: Boolean,
      default: true,
    },
    showPaypal: {
      type: Boolean,
      default: true,
    },
    showPaypal2: {
      type: Boolean,
      default: true,
    },
    showRappi: {
      type: Boolean,
      default: true,
    },
    showWalmart: {
      type: Boolean,
      default: true,
    },
    showBenavides: {
      type: Boolean,
      default: true,
    },
    showSams: {
      type: Boolean,
      default: true,
    },
    showSeven: {
      type: Boolean,
      default: true,
    },
    hideInPaymentSection: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      paymentMethods: [] as PaypmentMethodHome[],
    };
  },

  computed: {
    isLargeScreen() {
      return window.innerWidth > 992;
    },
  },
  mounted() {
    const payments = [
      {
        id: 1,
        name: "visa",
        image: "/images/payments/banner/visa.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showVisa,
      },
      {
        id: 2,
        name: "master",
        image: "/images/payments/banner/mastercard.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showMaster,
      },
      {
        id: 3,
        name: "paypal",
        image: "/images/payments/banner/paypal.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showPaypal,
      },
      {
        id: 4,
        name: "rappi",
        image: "/images/payments/banner/rappi.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showRappi,
      },
      {
        id: 5,
        name: "walmart",
        image: "/images/payments/banner/walmart.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showWalmart,
      },
      {
        id: 6,
        name: "benavides",
        image: "/images/payments/banner/benavides.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showBenavides,
      },
      {
        id: 7,
        name: "sams",
        image: "/images/payments/banner/sams.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showSams,
      },
      {
        id: 8,
        name: "seven",
        image: "/images/payments/banner/711.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showSeven,
      },
      {
        id: 10,
        name: "visa",
        image: "/images/payments/banner/visa.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showVisa2,
      },
      {
        id: 11,
        name: "master",
        image: "/images/payments/banner/mastercard.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showMaster2,
      },
      {
        id: 12,
        name: "paypal",
        image: "/images/payments/banner/paypal.svg",
        link: "url",
        status: this.showInProductDetail,
        show: this.showPaypal2,
      },
    ];

    this.paymentMethods = this.isLargeScreen
      ? payments
      : payments.filter((item) => [1, 2, 3, 5].includes(item.id));
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/product";
.image-payment {
  width: 80%;
  max-height: 20px;
  object-fit: contain;
}

.height-col {
  height: 24px;

  @media (min-width: 576px) {
    height: 35px;
  }

  @media (min-width: 768px) {
    height: 48px;
  }

  @media (min-width: 992px) {
    height: 100%;
  }
}
</style>
